export default class SegmentData {
  constructor(
    public title: string,
    public count: number,
  ) {
  }
}
